import { render, staticRenderFns } from "./OpenVouchers.vue?vue&type=template&id=5aee1154"
import script from "./OpenVouchers.vue?vue&type=script&lang=ts"
export * from "./OpenVouchers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports